<template>
  <div>
    <div class="layout-langs">
      <span :class="['pointer', $store.state.lang == 'es' ? 'selected-acttiv-lang': 'acttiv-lang']" @click="$store.commit('changeLang', 'es')">Spanish</span> | 
      <span :class="['pointer', $store.state.lang == 'en' ? 'selected-acttiv-lang': 'acttiv-lang']" @click="$store.commit('changeLang', 'en')">English</span> | 
      <span :class="['pointer', $store.state.lang == 'pt' ? 'selected-acttiv-lang': 'acttiv-lang']" @click="$store.commit('changeLang', 'pt')">Portuguese</span>
    </div>
    <div>
      <main-list />
    </div>
    <div class="layout-footer">© Created by Smile and Learn</div>
  </div>
</template>
<script>

import { defineComponent, ref } from 'vue';
import MainList from './MainList.vue';
export default defineComponent({
  components:{
     MainList
  },
  setup() {
    return {
      selectedKeys: ref(['2']),
    };
  },
  data(){
    return {
      lang: 'es'
    }
  }
});
</script>
<style>



</style>